import { render, staticRenderFns } from "./recyclebin.vue?vue&type=template&id=60a2c38e&scoped=true&"
import script from "./recyclebin.vue?vue&type=script&lang=js&"
export * from "./recyclebin.vue?vue&type=script&lang=js&"
import style0 from "./recyclebin.vue?vue&type=style&index=0&id=60a2c38e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a2c38e",
  null
  
)

export default component.exports